module.exports = __webpack_public_path__ + "img/treat-1.3a74b961.svg";